// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"createNewMediaCompanyShort_buttonsWrapper__jXaYH","wrapper":"createNewMediaCompanyShort_wrapper__u9wDK"};